export default __webpack_public_path__ + "static/energy-focus-60558cb37c7f3a31330297365378a21a.png";